<!--
 * @Description: 申请钱账通商户代理抽屉组件
 * @Author: sunhuihong
 * @Date: 2026-05-07 16:43:52
 * @LastEditTime: 2026-05-08 15:16:43
-->
<template>
  <div class="agnet-mch-apply-body">
    <el-drawer label="rtl" size="1000px" title="开通提现账户" :visible.sync="visible" 
      :before-close="handleClose" @open="initData">
      <div class="tips">
        <i class="el-icon-warning"></i>
        <span>平台已开通钱账通功能，请在此处提交资料，审核成功后服务收入方可到账银行账户</span>
      </div>
      <div class="container">
        <iframe :src="mchApplySrc" width="100%" height="100%"
          title="mchApply" name="mchApply">
        </iframe>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
export default {
  name: 'AgentMchApplyDrawer',
  props: ['visible', 'agentId'],

  data() {
    return {
      mchApplySrc: ''
    }
  },
  
  methods: {
    initData() {
      let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_AGENT_MCH_APPLY_URL, 
        this.agentId);
      let requestData = {
        method: 'GET',
        url: url,
        param: null,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.mchApplySrc = result.data;
      })
    },

    handleClose() {
      this.$emit('close-drawer');
    },
  },
}
</script>

<style scoped>
.agnet-mch-apply-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.agnet-mch-apply-body .tips {
  padding: 0 30px;
  height: 38px;
  display: flex;
  align-items: center;
  text-align: left;
  background: #F7F9FE;
  margin: 9px 0px 24px 0px;
}

.agnet-mch-apply-body .tips i {
  color: #E9A338;
  font-size: 14px;
}

.agnet-mch-apply-body .tips span {
  font-size: 12px;
  color: #606266;
  line-height: 16px;
  margin-left: 12px;
}

.agnet-mch-apply-body .container {
  height: 85%;
  padding: 0 30px;
  background: #FFFFFF;
}

</style>
<style>
.agnet-mch-apply-body .el-drawer {
  border-radius: 12px 0px 0px 12px;
}

.agnet-mch-apply-body .el-drawer__header {
  padding: 15px 40px 15px !important;
}

.agnet-mch-apply-body .el-drawer__close-btn {
    position: absolute;
    top: 15px;
    right: 40px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/usermng/components/AgentMchApplyDrawer.vue